import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { FC, memo } from 'react';

import classes from './BlockedUnsafeMedia.module.css';

type Props = {
    fileName?: string;
};

const BlockedUnsafeMedia: FC<Props> = ({ fileName }) => {
    const { _ } = useLingui();

    return (
        <div className={classes.wrap} role="alert">
            <p className={classes.title}>{_(msg`File blocked`)}</p>
            <p className={classes.sub}>
                {_(msg`This file type cannot be opened or downloaded for security reasons.`)}
            </p>
            {fileName ? <p className={classes.name}>{fileName}</p> : null}
        </div>
    );
};

export default memo(BlockedUnsafeMedia);
